import { STEP } from "../../../shared/constants";

export function changeLoading(loading) {
	return {
		type: "@auth/CHANGE_LOADING",
		payload: {
			loading,
		},
	};
}

export function authenticateRequest(cpf, password, isProAuth, options, toMarket, tokenRecaptcha, adid) {
	return {
		type: "@auth/AUTHENTICATE_REQUEST",
		payload: { cpf, password, isProAuth, options, toMarket, tokenRecaptcha, adid },
	};
}

/**
 * @param {string} reason
 *
 */
export function logoutRequest(reason) {
	return {
		type: "@auth/LOGOUT",
		payload: { reason },
	};
}

/**
 *
 * @param {{reason: string, newLogin: any, isLoginAfterOnboarding?: boolean}} payload
 */
export function logoutAndLoginForced(payload) {
	return {
		type: "@auth/LOGOUT_AND_LOGIN_FORCED",
		payload,
	};
}

export function authenticatePrepareLogin(cpf, password, isProAuth, options, toMarket, adid) {
	return {
		type: "@auth/AUTHENTICATE_PREPARE_LOGIN",
		payload: { cpf, password, isProAuth, options, toMarket, adid },
	};
}

export function respRequestError(error) {
	return {
		type: "@auth/RESP_REQUEST_ERROR",
		payload: { error },
	};
}

export function socialMediaAuthenticateRequest(cpf, password, sso, sig) {
	return {
		type: "@auth/SOCIAL_MEDIA_AUTHENTICATE_REQUEST",
		payload: { cpf, password, sso, sig },
	};
}

export function redirectAuthenticatedRequest(
	billingStatus,
	investor,
	multiBroker,
	cd_access_token,
	accounts,
	guardStatus,
	isProAuth,
	options,
	toMarket,
	tradeChat
) {
	return {
		type: "@auth/REDIRECT_AUTHENTICATED",
		payload: {
			billingStatus,
			investor,
			multiBroker,
			cd_access_token,
			accounts,
			guardStatus,
			isProAuth,
			options,
			toMarket,
			tradeChat,
		},
	};
}

export function trackEvent(id_investor) {
	return {
		type: "@auth/TRACK_EVENT",
		payload: { id_investor },
	};
}

export function setAuthenticated(authenticated) {
	return {
		type: "@auth/SET_AUTHENTICATED",
		payload: { authenticated },
	};
}

export function loginWithTokenByRedirect(data) {
	return {
		type: "@auth/LOGIN_WITH_TOKEN_BY_REDIRECT",
		payload: data,
	};
}

export function loginWithTokenByRedirectPortal(data) {
	return {
		type: "@auth/LOGIN_WITH_TOKEN_BY_REDIRECT_PORTAL",
		payload: data,
	};
}

export function socialLogin(token, socialNetworkId, toMarket) {
	return {
		type: "@auth/SOCIAL_LOGIN",
		payload: { token, socialNetworkId, toMarket },
	};
}

export function setNewUsername(isValue) {
	return {
		type: "@auth/SET_NEW_USERNAME",
		payload: { isValue },
	};
}

export function loadingSocialLogin(boo) {
	return {
		type: "@auth/LOADING_SOCIAL_LOGIN",
		payload: { boo },
	};
}

export function showModalSocialLogin(boo) {
	return {
		type: "@auth/SHOW_MODAL_SOCIAL_LOGIN",
		payload: { boo },
	};
}

export function removeCacheForLogin(param) {
	return {
		type: "@auth/REMOVE_CACHE_FOR_LOGIN",
		payload: { param },
	};
}

export function showMessageLoginFail(param) {
	return {
		type: "@auth/SHOW_MESSAGE_LOGIN_FAIL",
		payload: { param },
	};
}

export function setRecaptchaError(param) {
	return {
		type: "@auth/SET_RECAPCTHA_ERROR",
		payload: { param },
	};
}

/**
 *
 * @param {typeof import("../../../shared/constants/index").STEP} step
 * @returns
 */
export function setCredentialFlowStep(step) {
	return {
		type: "@AUTH/CREDENTIAL_FLOW_STEP",
		payload: { step },
	};
}
